import { render, staticRenderFns } from "./qrCourseImport.vue?vue&type=template&id=2bb0d654"
import script from "./qrCourseImport.vue?vue&type=script&lang=js"
export * from "./qrCourseImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports